import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { DocumentDisableRemindersPayload } from 'Interfaces/Document';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((values: DocumentDisableRemindersPayload) =>
    $actions.document.toggleEmailNotification(dispatch, values),
  );
};
